
define('text!templates/widgets/pager/sizePicker.html',[],function () { return '<select class="form-control input-sm page-size-entry" data-bind="\n    options: allowedPageSizes,\n    value: pageSize,\n    lAttr: {&apos;aria-label&apos;: &apos;pager.sizePicker.label&apos;}\n">\n</select>';});

